module.exports = __webpack_public_path__ + "img/item-bg.04338212.png";